import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { fanPrefix } from '../../constant';
import useFormFields from '../../hooks/useFormFields';
import AccountDetails from '../accountDetails/AccountDetails';
import ErrorView from '../errors/ErrorView';
import { PrimaryButtonSto } from '../sto';

function AccountDetailsForm(props) {
    const { formFields, setFormField } = useFormFields({
        accountNumber: '',
        phoneNumber: '',
        postalCode: '',
    });

    const { accountNumber, phoneNumber, postalCode } = formFields;

    const [isFormValid, setFormValidity] = useState(false);

    useEffect(() => {
        setFormValidity(accountNumber.isValid && postalCode.isValid && phoneNumber.isValid);
    }, [accountNumber, phoneNumber, postalCode]);

    const handleSubmitClick = (e) => {
        e.preventDefault();

        if (isFormValid) {
            props.onSubmit({
                accountNumber: fanPrefix + accountNumber.value,
                phoneNumber: phoneNumber.value,
                postalCode: postalCode.value.toUpperCase(),
            });
        }
    };

    return (
        <div>
            <ErrorView error={props.error} />

            <form onSubmit={handleSubmitClick}>
                <AccountDetails
                    accountNumber={accountNumber}
                    phoneNumber={phoneNumber}
                    postalCode={postalCode}
                    setFormField={setFormField}
                />

                <PrimaryButtonSto disabled={!isFormValid} labelKey="pages.button.continue" type="submit" />
            </form>
        </div>
    );
}

AccountDetailsForm.propTypes = {
    error: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
};

export default AccountDetailsForm;
